import { render, staticRenderFns } from "./ThgChargingStationUpdateView.vue?vue&type=template&id=8ff70342&scoped=true&"
import script from "./ThgChargingStationUpdateView.vue?vue&type=script&lang=ts&"
export * from "./ThgChargingStationUpdateView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff70342",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
